export default {
  headerContent: {
    title: 'Groupama Sigorta Kasko Sigortası Teklifi Hesaplama',
    slogan: "Araç Kasko Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ARAÇ KASKO SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Groupama Sigorta Araç Kasko Sigortası',
    description: {
      title: 'Groupama Sigorta Araç Kasko Sigortası Nedir? ',
      content: [
        'Kasko sigortası, motorlu taşıtı çarpma, çarpılma, devrilme ve hırsızlık gibi olaylar sonucu oluşacak hasar masrafları karşısında güvence sağlamaktadır.',
        'Otomobil sigortası gereklidir, çünkü sürücülere bir kazadan sonra veya çalınma, hırsızlık gibi diğer kazalara karşı var olan riskleri kapsam dâhilindeki tehlikelerden kaynaklanan hasar için tazminat sağlar.',
        'En iyi plan, hangi teminatlara ve seçeneklere ihtiyacınız olduğuna ve karşılaştırmalı fiyatlara öncelik vermektir, böylece yeterli teminat sağlayan ucuz otomobil sigortasını Alokasko.com ile bulabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Groupama Sigorta Araç Kasko Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Kasko sigortası isteğe bağlı bir sigorta ürünüdür. Aracınızı ve bütçenizi olası kaza durumlarına karşı güvence altında tutmak için yaptırabilirsiniz.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Araç Kasko Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Araç Kasko Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Groupama Sigorta Araç Kasko Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
